module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBold-70e5fd73e9b07b746f02c1705f5ecb26.ttf";